// extracted by mini-css-extract-plugin
export default {"button":"icon-button_button__VerhJ"};